import { render, staticRenderFns } from "./apiPage.vue?vue&type=template&id=725c35ae"
import script from "./apiPage.vue?vue&type=script&lang=js"
export * from "./apiPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports